import { render, staticRenderFns } from "./Startups.vue?vue&type=template&id=03299866&scoped=true&"
import script from "./Startups.vue?vue&type=script&setup=true&lang=js&"
export * from "./Startups.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03299866",
  null
  
)

export default component.exports